import useLogout from '@rhg/hooks/use-logout';
import useAuth from '@rhg/libs/auth0/use-auth';
import { GUIDE_PLAYER_OPEN_STATE_KEY } from '@rhg/providers/guide-player';
import { getCurrentTime } from '@rhg/utils/date-time';
import { useEffect, useRef } from 'react';

/**
 * Log the user out if they have been inactive for this duration.
 *
 * `milliseconds * seconds * minutes = 29.5 minutes` 30 seconds shorter than the JWT expiration
 */
const timeoutDelay = 1000 * 60 * 59.5;
export const MOST_RECENT_INTERACTION_KEY = 'most_recent_interaction';

const HeartBeat = () => {
    const timeoutRef = useRef(-1);
    const { isAuthenticated } = useAuth();
    const { logout } = useLogout();
    // using a ref to make sure we have the latest value when the timer ticks
    const isAuthenticatedRef = useRef<boolean>();

    useEffect(() => {
        isAuthenticatedRef.current = isAuthenticated;
    }, [isAuthenticated]);

    useEffect(() => {
        const resetTimer = () => {
            const currentTime = getCurrentTime();
            // eslint-disable-next-line no-restricted-syntax
            localStorage.setItem(
                MOST_RECENT_INTERACTION_KEY,
                currentTime.toString()
            );

            if (timeoutRef.current) {
                window.clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = window.setTimeout(() => {
                const lastInteractionTime = Number(
                    // eslint-disable-next-line no-restricted-syntax
                    localStorage.getItem(MOST_RECENT_INTERACTION_KEY)
                );

                const logoutThreshold = getCurrentTime() - timeoutDelay;
                const difference = lastInteractionTime - logoutThreshold;

                if (difference > 0) {
                    return;
                }

                // eslint-disable-next-line no-restricted-syntax
                const openState = localStorage.getItem(
                    GUIDE_PLAYER_OPEN_STATE_KEY
                );
                if (openState) {
                    return;
                }
                if (isAuthenticatedRef.current) {
                    logout();
                }
            }, timeoutDelay);
        };

        window.addEventListener('click', resetTimer);
        window.addEventListener('keypress', resetTimer);
        resetTimer();

        return () => {
            window.removeEventListener('click', resetTimer);
            window.removeEventListener('keypress', resetTimer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default HeartBeat;
